import { Injectable } from '@angular/core';
import * as Highcharts from 'highcharts';
import { Subject } from 'rxjs';



const Exporting = require("highcharts/modules/exporting");
const ExportData = require("highcharts/modules/export-data");

Exporting(Highcharts);
ExportData(Highcharts);

declare var require: any;
let Boost = require('highcharts/modules/boost');
let noData = require('highcharts/modules/no-data-to-display');
let More = require('highcharts/highcharts-more');
let threeD = require('highcharts/highcharts-3d');



let dumbbellSeries=require('highcharts/modules/dumbbell');
let sankey = require("highcharts/modules/sankey");
let organization = require("highcharts/modules/organization");

Boost(Highcharts);

More(Highcharts);

threeD(Highcharts);

noData(Highcharts);
dumbbellSeries(Highcharts);
sankey(Highcharts);
organization(Highcharts);


@Injectable({
  providedIn: 'root'
})
export class IndashboardService {

  constructor() { }
 
  private chartClick = new Subject<any>();
  getChartClickData$ = this.chartClick.asObservable();

  onClickChartMethodFromComponent(data) {
    this.chartClick.next(data);
  }


  highcharts = Highcharts;

  
  barChartOptions={
    
    chart: {
      type: ''
  },
  title: {
      text: ''
  },
  subtitle: {
      text: ''
  },
  xAxis: {
      categories: [],
      title: {
          text: null
      }
  },
  yAxis: {
      min: 0,
      title: {
          text: '',
          align: 'high'
      },
      labels: {
          overflow: 'justify'
      }
  },
  tooltip: {
      valueSuffix: ''
  },
  plotOptions: {
      bar: {
          dataLabels: {
              enabled: true
          },
          colorByPoint:true,
          cursor:'Pointer',
      },
      column: {
          dataLabels: {
              enabled: true
          },
          colorByPoint:true,
          cursor:'Pointer',
      },
      
      series: {
        events: {
          click: (event) => {
            this.onClickChartDetails(event)  
            
          },
        },
      }
  },
  legend: {
    enabled: false
      // layout: 'vertical',
      // align: 'right',
      // verticalAlign: 'top',
      // x: -40,
      // y: 80,
      // floating: true,
      // borderWidth: 1,
      // backgroundColor:
      //     Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
      // shadow: true
  },
  credits: {
      enabled: false
  },
 colors:['#78E1DB','#69DE73'],
  series: [
    {
      name: '',
      data: [0,0]
  }
    
],
exporting: {
    buttons: {
      contextButton: {
        menuItems: ["viewFullscreen",
                    "printChart",
                    "separator",
                    "downloadPNG",
                    "downloadJPEG",
                    "downloadPDF",
                    "downloadSVG",
                    "separator",
                    "downloadCSV",
                    "downloadXLS",
                    // "viewData",
                    "openInCloud"]
      }
    }
  }

//   chart.update({
//     plotOptions: {
//       series: {
//         events: {
//           click: (event) => {
//             console.log(event);
//           },
//         },
//       },
//     }
//   });
}








  columnChartOptions={
    
    chart: {
      type: ''
  },
  title: {
      text: ''
  },
  subtitle: {
      text: ''
  },
  xAxis: {
      categories: [],
      title: {
          text: null
      }
  },
  yAxis: {
      min: 0,
      title: {
          text: '',
          align: 'high'
      },
      labels: {
          overflow: 'justify'
      }
  },
  tooltip: {
      valueSuffix: ''
  },
  plotOptions: {
      bar: {
          dataLabels: {
              enabled: true
          },
          colorByPoint:true,
          cursor:'Pointer',
      },
      column: {
          dataLabels: {
              enabled: true
          },
          colorByPoint:true,
          cursor:'Pointer',
      },
      line: {
          dataLabels: {
              enabled: true
          },
          colorByPoint:false,
          cursor:'Pointer',
      },
      series: {
        events: {
          click: (event) => {
            this.onClickChartDetails(event);
          },
        },
      }
  },
  legend: {
    enabled: false
      // layout: 'vertical',
      // align: 'right',
      // verticalAlign: 'top',
      // x: -40,
      // y: 80,
      // floating: true,
      // borderWidth: 1,
      // backgroundColor:
      //     Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
      // shadow: true
  },
  credits: {
      enabled: false
  },
 colors:['#78E1DB','#69DE73'],
  series: [
    {
      name: '',
      data: [0,0]
  }
    
],
exporting: {
    buttons: {
      contextButton: {
        menuItems: ["viewFullscreen",
                    "printChart",
                    "separator",
                    "downloadPNG",
                    "downloadJPEG",
                    "downloadPDF",
                    "downloadSVG",
                    "separator",
                    "downloadCSV",
                    "downloadXLS",
                    // "viewData",
                    "openInCloud"]
      }
    }
  }
}

organizatinalChartOption={

   
        chart: {
            height: 600,
            inverted: false
        },
    
        title: {
            text: ''
        },
    
        accessibility: {
            point: {
                descriptionFormatter: function (point) {
                    var nodeName = point.toNode.name,
                        nodeId = point.toNode.id,
                        nodeDesc = nodeName === nodeId ? nodeName : nodeName + ', ' + nodeId,
                        parentDesc = point.fromNode.id;
                    return point.index + '. ' + nodeDesc + ', reports to ' + parentDesc + '.';
                }
            }
        },
    
        series: [{
            type: 'organization',
            name: 'Highsoft',
            keys: ['from', 'to'],
            data: [
                ['Shareholders', 'Board'],
                // ['Board', 'CEO'],
                // ['CEO', 'CTO'],
                // ['CEO', 'CPO'],
                // ['CEO', 'CSO'],
                // ['CEO', 'HR'],
                // ['CTO', 'Product'],
                // ['CTO', 'Web'],
                // ['CSO', 'Sales'],
                // ['HR', 'Market'],
                // ['CSO', 'Market'],
                // ['HR', 'Market'],
                // ['CTO', 'Market']
            ],
            levels: [{
                level: 0,
                color: 'red',
                dataLabels: {
                    color: 'black'
                },
                height: 25,
                
            }, {
                level: 1,
                color: 'silver',
                dataLabels: {
                    color: 'black'
                },
                height: 25
            }, {
                level: 2,
                color: '#980104'
            }, {
                level: 4,
                color: '#359154'
            }],
            nodes: [{
                id: 'Shareholders'
            }, {
                id: 'Board'
            }, {
                id: 'Shareholders',
                title: 'CEO',
                name: 'Grethe Hjetland',
                image: ''
            }, {
                id: 'Shareholders',
                title: 'HR/CFO',
                name: 'Anne Jorunn Fjærestad',
                color: '#007ad0',
                image: ''
            }, {
                id: 'Shareholders',
                title: 'CTO',
                name: 'Christer Vasseng',
                image: ''
            }, {
                id: 'Shareholders',
                title: 'CPO',
                name: 'Torstein Hønsi',
                image: ''
            }, {
                id: 'Shareholders',
                title: 'CSO',
                name: 'Anita Nesse',
                image: ''
            }, {
                id: 'Shareholders',
                name: 'Product developers'
            }, {
                id: 'Shareholders',
                name: 'Web devs, sys admin'
            }, {
                id: 'Shareholders',
                name: 'Sales team'
            }, {
                id: 'Shareholders',
                name: 'Marketing team',
                column: 5
            }],
            colorByPoint: false,
            color: '#007ad0',
            dataLabels: {
                color: 'white'
            },
            borderColor: 'white',
            nodeWidth: 65
        }],
        tooltip: {
            outside: true
        },
        exporting: {
            allowHTML: true,
            sourceWidth: 800,
            sourceHeight: 600
        }
    
   



}

stackedChartOptions={
    chart: {
        type: ''
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: []
    },
    yAxis: {
        min: 0,
        title: {
            text: ''
        },
       
            // stackLabels: {
            //     formatter: function() {
            //         // if this label is for pears, return nothing
            //         if(this.axis.chart.xAxis[0].categories[this.x] == 'Pears')
            //             return;
            //         // if not, return the default
            //         else
            //             return this.total; 
            //     }
            // },
        
        stackLabels: {
            enabled: false,
            style: {
                fontWeight: 'bold',
                color: ( // theme
                    Highcharts.defaultOptions.title.style &&
                    Highcharts.defaultOptions.title.style.color
                ) || 'gray'
            }
        }
    },
    legend: {
        // align: 'right',
        // x: -30,
        // verticalAlign: 'top',
        // y: 25,
        // floating: true,
        // backgroundColor:
        //     Highcharts.defaultOptions.legend.backgroundColor || 'white',
        // borderColor: '#CCC',
        // borderWidth: 1,
        // shadow: false
    },
    tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>'
        // pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
    },
    plotOptions: {
        column: {
            stacking: 'normal',
            dataLabels: {
                enabled: true
            },
            // colorByPoint:true
            cursor:'Pointer'
        },
        
        series: {
            events: {
              click: (event) => {
                this.onClickChartDetails(event);
              },
            },
            stacking: 'percent'
          }
    },
    credits:{
        enabled:false
    },
    
    series: [{
        name: 'Consumption',
        data: [],
        color:''
    }, {
        name: 'Stock',
        data: [],
        color:''
    }],
    exporting: {
        buttons: {
          contextButton: {
            menuItems: ["viewFullscreen",
                        "printChart",
                        "separator",
                        "downloadPNG",
                        "downloadJPEG",
                        "downloadPDF",
                        "downloadSVG",
                        "separator",
                        "downloadCSV",
                        "downloadXLS",
                        //"viewData",
                        "openInCloud"]
          }
        }
      }
}

pieChartOptions={  
    chart: {
        type: '',
        options3d: {
            enabled: true,
            alpha: 45,
            beta: 0,
            viewDistance: 20,
            depth: 20
        }
    },
    title: {
        text: ''
    },
    accessibility: {
        point: {
            valueSuffix: '%'
        }
    },
    tooltip: {
        pointFormat: '{series.name}: <b>Qty- {point.y} ({point.percentage:.1f}%)</b>'
    },
    plotOptions: {
        pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            depth: 35,
            dataLabels: {
                enabled: true,
                format: '{point.name}<br/> <b>{point.percentage:.1f}%</b>'
            }
        },
        colorByPoint:true
    },
    credits:{
      enabled:false
    },
    colors:['#00F591','#FF0000','#0036F4','#FF00E0','#FDFB1F','#00D8E6'],
    series: [{
        type: 'pie',
        name: '',
        data: []
    }],
    exporting: {
        buttons: {
          contextButton: {
            menuItems: ["viewFullscreen",
                        "printChart",
                        "separator",
                        "downloadPNG",
                        "downloadJPEG",
                        "downloadPDF",
                        "downloadSVG",
                        "separator",
                        "downloadCSV",
                        "downloadXLS",
                        //"viewData",
                        "openInCloud"]
          }
        }
      }
}

dumbbellChartOptions={
    chart: {
        type: 'dumbbell',
        inverted: true
    },

    legend: {
        enabled: false
    },

    subtitle: {
        text: '1960 vs 2018'
    },

    title: {
        text: 'Change in Life Expectancy'
    },

    tooltip: {
        shared: true
    },

    xAxis: {
        type: 'category'
    },

    yAxis: {
        title: {
            text: 'Life Expectancy (years)'
        }
    },

    series: [{
        name: 'Life expectancy change',
        data: [{
            name: 'Austria',
            low: 69,
            high: 82
        }, {
            name: 'Belgium',
            low: 70,
            high: 81
        }, {
            name: 'Bulgaria',
            low: 69,
            high: 75
        }, {
            name: 'Croatia',
            low: 65,
            high: 78
        }, {
            name: 'Cyprus',
            low: 70,
            high: 81
        }, {
            name: 'Czech Republic',
            low: 70,
            high: 79
        }, {
            name: 'Denmark',
            low: 72,
            high: 81
        }, {
            name: 'Estonia',
            low: 68,
            high: 78
        }, {
            name: 'Finland',
            low: 69,
            high: 81
        }, {
            name: 'France',
            low: 70,
            high: 83
        }, {
            name: 'Greece',
            low: 68,
            high: 81
        }, {
            name: 'Spain',
            low: 69,
            high: 83
        }, {
            name: 'Netherlands',
            low: 73,
            high: 82
        }, {
            name: 'Ireland',
            low: 70,
            high: 82
        }, {
            name: 'Lithuania',
            low: 70,
            high: 75
        }, {
            name: 'Luxembourg',
            low: 68,
            high: 83
        }, {
            name: 'Latvia',
            low: 70,
            high: 75
        }, {
            name: 'Malta',
            low: 69,
            high: 82
        }, {
            name: 'Germany',
            low: 69,
            high: 81
        }, {
            name: 'Poland',
            low: 68,
            high: 78
        }, {
            name: 'Portugal',
            low: 63,
            high: 81
        }, {
            name: 'Romania',
            low: 66,
            high: 75
        }, {
            name: 'Slovakia',
            low: 70,
            high: 77
        }, {
            name: 'Slovenia',
            low: 69,
            high: 81
        }, {
            name: 'Sweden',
            low: 73,
            high: 82
        }, {
            name: 'Hungary',
            low: 68,
            high: 76
        }, {
            name: 'Italy',
            low: 69,
            high: 83
        }, {
            name: 'UK',
            low: 71,
            high: 81
        }]
        
    }],
    exporting: {
        buttons: {
          contextButton: {
            menuItems: ["viewFullscreen",
                        "printChart",
                        "separator",
                        "downloadPNG",
                        "downloadJPEG",
                        "downloadPDF",
                        "downloadSVG",
                        "separator",
                        "downloadCSV",
                        "downloadXLS",
                        //"viewData",
                        "openInCloud"]
          }
        }
      }
}

columnRangeChartOptions={
    chart: {
        type: 'columnrange',
        inverted: true
    },

    accessibility: {
        description: ''
    },

    title: {
        text: 'Procurement Matrix'
    },

    subtitle: {
        text: ''
    },

    xAxis: {
        categories: ['Dep Approve', 'Fin Dep Approve', 'MGT Approve', 'NOA Approve', 'Req Approve', 'Spec Comm Approve',
            'Tender Notice']
    },

    yAxis: {
        title: {
            text: 'Matrix'
        }
    },

    tooltip: {
        valueSuffix: ''
    },

    plotOptions: {
        columnrange: {
            dataLabels: {
                enabled: true,
                format: ''
                // format: '{y}°C'
            }
        }
    },

    legend: {
        enabled: false
    },
    credits:{
        enabled:false
    },
    series: [{
        name: 'Approval Status',
        data: [           
            [],
            [],
            [],
            [],
            [],
            [],
            []
            // [3.7, 25.4],
            // [6.0, 26.2],
            // [6.7, 21.4],
            // [3.5, 19.5],
            // [-1.3, 16.0],
            // [-8.7, 9.4],
            // [-9.0, 8.6]
        ]
    }],
    exporting: {
        buttons: {
          contextButton: {
            menuItems: ["viewFullscreen",
                        "printChart",
                        "separator",
                        "downloadPNG",
                        "downloadJPEG",
                        "downloadPDF",
                        "downloadSVG",
                        "separator",
                        "downloadCSV",
                        "downloadXLS",
                        //"viewData",
                        "openInCloud"]
          }
        }
      }
}

donutChartOptions = {
    chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
    },
    title: {
        text: 'Manpower Requisition'
    },
    tooltip: {
        pointFormat: '{series.name}: <b> Qty- {point.y} ({point.percentage:.1f}%)</b>'
    },
    accessibility: {
        point: {
            valueSuffix: '%'
        }
    },
    credits: {
      enabled: false
    },
    plotOptions: {
        pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                connectorColor: 'silver'
            }
        }
    },
    series: [{
        innerSize: '70%',
        data: [ ]
    }],
    exporting: {
        buttons: {
          contextButton: {
            menuItems: ["viewFullscreen",
                        "printChart",
                        "separator",
                        "downloadPNG",
                        "downloadJPEG",
                        "downloadPDF",
                        "downloadSVG",
                        "separator",
                        "downloadCSV",
                        "downloadXLS",
                        //"viewData",
                        "openInCloud"]
          }
        }
      }
  }

scatterChartOptions={
    chart: {
        type: 'scatter',
        zoomType: 'xy'
    },
    title: {
        text: ''
    },
    subtitle: {
        text: ''
    },
    xAxis: {
        title: {
            enabled: true,
            text: 'Quantity'
        },
        startOnTick: true,
        endOnTick: true,
        showLastLabel: true
    },
    yAxis: {
        title: {
            text: 'Aging Days'
        }
    },
    legend: {
        enabled:false
        // layout: 'vertical',
        // align: 'left',
        // verticalAlign: 'top',
        // x: 100,
        // y: 70,
        // floating: true,
        // backgroundColor: Highcharts.defaultOptions.chart.backgroundColor,
        // borderWidth: 1
    },
    plotOptions: {
        scatter: {
            marker: {
                radius: 5,
                states: {
                    hover: {
                        enabled: true,
                        lineColor: 'rgb(100,100,100)'
                    }
                }
            },
            states: {
                hover: {
                    marker: {
                        enabled: false
                    }
                }
            },
            tooltip: {
                headerFormat: '<b>{series.name}</b><br>',
                pointFormat: '{point.x} Quantity, {point.y} Days'
                // pointFormat: '{point.x} cm, {point.y} kg'
            }
        }
    },
    credits:{
        enabled:false
    },
    series: [    
    {
        name: 'Item',
        color: 'rgba(119, 152, 191, .5)',
        data: [[174.0, 65.6]]
    }],
    exporting: {
        buttons: {
          contextButton: {
            menuItems: ["viewFullscreen",
                        "printChart",
                        "separator",
                        "downloadPNG",
                        "downloadJPEG",
                        "downloadPDF",
                        "downloadSVG",
                        "separator",
                        "downloadCSV",
                        "downloadXLS",
                        //"viewData",
                        "openInCloud"]
          }
        }
      }
}

buttonFlags=
[
    {name:'inventory',status:true},
    {name:'re-order',status:true},
    {name:'overdue',status:true},
    {name:'expiry batch',status:true},
    {name:'material stock',status:true},
    {name:'aging',status:true},
    {name:'top issued',status:true},
    {name:'upcoming expiary batch',status:true},
    {name:'store stock',status:true},
    {name:'material consumption',status:true},
];

zonalOffices={
    inStockZonalOffice:'',
    materialIssuePendingZonalOffice:'',
    stockCheckZonalOffice:'',
    inventoryPositionZonalOffice:'',
    itemsForReOrderzonalOffice:'',
    receiveOverdueZonalOffice:'',
    itemsExpiaryBatchZonalOffice:'',
    upcomingItemExpiaryBatchZonalOffice:'',
    materialStockZonalOffice:'',
    itemWiseAgingStatusZonalOffice:'',
    topIssuedItems:'',
    storeStockZonalOfiice:'',
    materialConsumptionZonalOfiice:'',
}

chartLoderOptions={
    inStockChartLoader:true,
    materialIssuePendingChartLoader:true,
    stockCheckChartLoader:true,
    inventoryPositionChartLoader:true,
    itemsForReOrderChartLoader:true,
    receiveOverdueChartLoader:true,
    itemsExpiaryBatchChartLoader:true,
    materialStockChartLoader:true,
    materialConsumptionChartLoader:true,
    itemWiseAgingStatusChartLoader:true,
    topIssuedItemsChartLoader:true,
    upcomingItemExpireChartLoader:true,
    storeStockLoader:true,
}
createChartClickParams={
    P_START_DATE:'',
    P_END_DATE:'',
    P_BU_NO:'',
    P_CATEGORY_NO:'',
    P_ITEM_NO:''
}
onClickChartDetails(event){
    this.onClickChartMethodFromComponent(event);
    

}



}
